<div *ngIf="isLoading">Loading Asset List...</div>

<select *ngIf="!isLoading" [compareWith]="byId" class="form-control" name="asset" [(ngModel)]="model.asset" [required]="required">
  <option *ngFor="let singleAsset of assets" [ngValue]="singleAsset">{{ singleAsset.name }}</option>
</select>
